module.exports = __webpack_public_path__ + "img/leaderboard-up.f30329a8.svg";